import { useDraggable } from '@dnd-kit/core';
import { useState } from 'react';
import clsx from 'clsx';
import { Module } from './Module/Module';
import styles from './DraggableModule.module.scss';
import type { ModuleVersionGroup } from '../../groupModulesByVersion';

interface DraggableModuleProperties {
  group: ModuleVersionGroup;
}

export function DraggableModule({ group }: DraggableModuleProperties) {
  const [selectedVersion, setSelectedVersion] = useState(
    group.latest.version
  );
  const selectedModule =
    group.versions.find((module) => module.version === selectedVersion) ??
    group.latest;

  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    data: selectedModule,
    id: `module-${group.latest.textId}`,
  });

  return (
    <div
      ref={setNodeRef}
      className={clsx(styles.draggableModule, {
        [styles.dragging]: isDragging,
        [styles.notDragging]: !isDragging,
      })}
      {...listeners}
      {...attributes}
    >
      <Module
        module={selectedModule}
        availableVersions={group.versions.map((module) => module.version)}
        onVersionChange={setSelectedVersion}
      />
    </div>
  );
}

export default DraggableModule;

